import { DynamicLoaderRegistry } from '@tencent/workbench';
import { loadTask } from '@framework/workbench/common/service/tasks/load-task';
import type { IBaseDrawerFeature } from '@src/framework/workbench/common/feature/base-drawer-interface';
import { DatetimeFieldType } from '@src/slide/domain/ui-model/element-modeles/property/text/utils/format-datetime';
import { DatetimeType } from '@src/slide/domain/ui-model/element-modeles/property/slide-footer/slide-footer.interface';

export interface ISlideFooterFeature extends IBaseDrawerFeature {
    getSlideNumberStartIndex(): number;
    updateSlideNumberStartIndex(index: number): void;
    shouldSlideNumberStartDisabled(): boolean;
    shouldSlideFooterDisabled(): boolean;
    handleApplyButtonClick(): void;
    getSlideNumberContent();
    getSlideFooterContent();
    getSlideFooterInputContent();
    getDatetimeContent();
    getDatetimeInputContent();
    updateDatetimeType(value: DatetimeType);
    getDatetimeType();
    shouldDatetimeOthersDisabled();
    getDatetimeFieldType();
    updateDatetimeFieldType(value: DatetimeFieldType);
}

export const ISlideFooterFeature = Symbol.for('feature:drawer-slide-footer');

DynamicLoaderRegistry.merge(ISlideFooterFeature, {
    useFactory: async () => {
        const { SlideFooterFeature } = await import('./slide-footer-feature');
        return SlideFooterFeature;
    },
    on: loadTask,
});
